import { HTMLAttributes } from "react";

export enum IconColor {
  WHITE = "#ffffff",
  DARK_THEME = "#313b49",
  BLACK = "#000000",
  YELLOW = "#ffd200",
  YELLOW_ACTIVE = "#fa9d10",
  YELLOW_SECONDARY = "#ef6b01",
  ORANGE = "#FA9D10",
  SAND_GRAY = "#313131",
  SHADE_GRAY = "#777777",
  ECLIPSE = "#373737",
  GREEN = "#35A300",
  CHARCOAL = "#444444",
  GAINSBORO = "#DADADA",
  APPROX_SILVER = "#B9B9B9",
  VIOLET = "#8F45D0",
  BLUE = "#4EA8EA",
  RED = "#F33131",
  BLUE_DARK = "#2E88FF",
  ABBEY = "#494b51",
  GRAY = "#323232",
  GRAY_LIGHT = "#f3f3f3",
  BORDER_DARK = "#343434",
  BORDER_LIGHT = "#ececec",
  BORDER_GRAY_DARK = "#494B51",
  BORDER_GRAY_LIGHT = "#CED2D7",
}

export interface IIcon extends HTMLAttributes<SVGElement> {
  width?: number;
  height?: number;
  fill?: string;
  fill_2?: string;
  fill_3?: string;
  stroke?: IconColor;
}
